module.exports = __webpack_public_path__ + "static/img/vattier.70bd3c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/vattier.png
// module id = FYTH
// module chunks = 0